// src/components/auth/PrivateRoute.jsx
import React from "react";
import { Route, Redirect } from "react-router-dom";
import useUserData from "../../hooks/user/useUserData";

const PrivateRoute = ({ component: Component, render, ...rest }) => {
  const { isLoggedIn, loading } = useUserData();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return null;
        }

        if (!isLoggedIn) {
          return <Redirect to="/not-found" />;
        }

        if (Component) return <Component {...props} />;
        if (typeof render === "function") return render(props);
        return null;
      }}
    />
  );
};

export default PrivateRoute;
